module.exports = __webpack_public_path__ + "img/emoji_47.163fa36b.png";